import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { BookOpen, Plus, ArrowRight } from "lucide-react";
import GlassCard from "../../components/ui-custom/GlassCard";
import Reveal from "../../components/ui-custom/Reveal";
import { Button } from "../../components/ui/button";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

const formatDate = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

const Stories = () => {
  const [stories, setStories] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/employees/stories`, { withCredentials: true })
      .then((res) => setStories(res.data.items || []))
      .catch(() => setStories([]));
  }, []);

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <h2 className="font-display font-semibold text-2xl text-foreground">Stories</h2>
        <Link to="/employees/stories/new">
          <Button className="btn-glow-primary gap-2">
            <Plus size={16} /> New Story
          </Button>
        </Link>
      </div>

      {stories === null && <p className="text-sm text-muted-foreground">Loading stories…</p>}

      {stories !== null && stories.length === 0 && (
        <Reveal>
          <GlassCard className="p-10 text-center">
            <span className="w-14 h-14 rounded-full bg-qcyan/10 border border-qcyan/25 flex items-center justify-center mx-auto mb-5">
              <BookOpen size={24} className="text-qcyan" />
            </span>
            <p className="text-foreground font-medium mb-1">No stories published yet.</p>
            <p className="text-sm text-muted-foreground">Be the first to share a business update or milestone.</p>
          </GlassCard>
        </Reveal>
      )}

      <div className="grid sm:grid-cols-2 gap-5">
        {stories?.map((story, i) => (
          <Reveal key={story.id} delay={i * 0.05}>
            <Link to={`/employees/stories/${story.id}`}>
              <GlassCard tilt className="p-6 h-full">
                {story.category && (
                  <span className="text-xs font-semibold text-qcyan uppercase tracking-wide">{story.category}</span>
                )}
                <h3 className="font-display font-semibold text-foreground text-lg mt-1.5 mb-2 flex items-start gap-1.5">
                  {story.title} <ArrowRight size={14} className="text-qcyan shrink-0 mt-1.5" />
                </h3>
                <p className="text-sm text-muted-foreground line-clamp-3 mb-3">{story.body}</p>
                <p className="text-xs text-muted-foreground">
                  {story.author_name} · {formatDate(story.created_at)}
                </p>
              </GlassCard>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
};

export default Stories;
